export enum signInErrors {
  ACCOUNT_IS_DISABLED = "account_is_disabled",
  SESSION_HAS_EXPIRED = "session_has_expired",
}
